(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Popper"), require("RhgCommon"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Popper", "RhgCommon", ], factory);
	else if(typeof exports === 'object')
		exports["roomDisplay.52c68d8b"] = factory(require("Popper"), require("RhgCommon"), require("vue"));
	else
		root["roomDisplay.52c68d8b"] = factory(root["Popper"], root["RhgCommon"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__246__, __WEBPACK_EXTERNAL_MODULE__2730__, __WEBPACK_EXTERNAL_MODULE__9274__) {
return 